import css from "styled-jsx/css";

export const splitScreen = css`
  @media (min-width: 30em) {
    :global(.split__screen::before) {
      height: 100%;
      width: 50%;
      background: #fff;
      position: fixed;
      content: " ";
      top: 0;
      right: 0;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
      -webkit-transform-origin: right;
      -ms-transform-origin: right;
      transform-origin: right;
      box-shadow: 15px 0 30px 0 rgb(0 0 0 / 18%);
    }
  }
`;
